import type { KpiGroupBlock } from '../../../types/investigator';

const STATUS_COLOURS: Record<string, string> = {
  positive: 'border-success/30 bg-success/10 text-success',
  warning:  'border-warning/30 bg-warning/10 text-warning',
  critical: 'border-destructive/30 bg-destructive/10 text-destructive',
  neutral:  'border-border bg-muted/40 text-foreground',
};

interface KpiTilesProps {
  block: KpiGroupBlock;
}

export default function KpiTiles({ block }: KpiTilesProps) {
  if (block.items.length === 0) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
      {block.items.map((item, i) => {
        const colourClass = STATUS_COLOURS[item.status ?? 'neutral'];
        return (
          <div
            key={i}
            className={`rounded-lg border px-4 py-3 flex flex-col gap-0.5 ${colourClass}`}
          >
            <span className="text-xs uppercase tracking-wider opacity-60">{item.label}</span>
            <span className="text-xl font-semibold font-mono leading-tight">{item.value}</span>
            {item.unit && (
              <span className="text-xs opacity-50">{item.unit}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
